var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightOnSolid = function SvgLightOnSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.03 2.47a.75.75 0 0 0-1.06 1.06l1 1a.75.75 0 0 0 1.06-1.06l-1-1ZM20.53 3.53a.75.75 0 0 0-1.06-1.06l-1 1a.75.75 0 0 0 1.06 1.06l1-1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 9.5a6.744 6.744 0 0 0 3 5.613V18.5A2.75 2.75 0 0 0 11 21.25h2a2.75 2.75 0 0 0 2.75-2.75v-3.387A6.75 6.75 0 1 0 5.25 9.5Zm4.5 7.25v-1.303h4.5v1.303h-4.5Zm0 1.75v-.25h4.5v.25c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5H2ZM20.5 8.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1ZM5.03 15.03a.75.75 0 1 0-1.06-1.06l-1 1a.75.75 0 1 0 1.06 1.06l1-1ZM19.53 13.97a.75.75 0 1 0-1.06 1.06l1 1a.75.75 0 1 0 1.06-1.06l-1-1Z",
    fill: "currentColor"
  })));
};
export default SvgLightOnSolid;